import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, FileCopySharp } from '@material-ui/icons';
import { Switch, Tooltip } from '@material-ui/core';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll, wsUpdate } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  ayuda: {
    color: '#999',
    fontSize: '0.85rem',
    marginBottom: '10px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código', accessor: 'code', width: 170 },
  { Header: 'Aplicación', accessor: 'description' },
  { Header: 'Restringir GPS falso', accessor: 'falseGps', excelEnabled: false, width: 150 },
  { Header: 'Validar versión', accessor: 'validateVersion', excelEnabled: false, width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function MobileApp(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [apps, setApps] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false); //Feedback visual para carga de datos

  //recargar Listado para usar en create y update
  async function loadApps() {
    setDataLoading(true);
    let response = await wsGetAll('oauth/app');
    setDataLoading(false);
    if (response.success) setApps(response.data);
  }

  async function toggleGeneral(app, campo, checked) {
    setApps((previas) =>
      previas.map((item) => (item.id === app.id ? { ...item, [campo]: checked } : item))
    );

    let response = await wsUpdate('oauth/app', app.id, { [campo]: checked ? 1 : 0 });
    if (response.success) {
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
      await loadApps();
    }
  }

  useEffect(() => {
    loadApps();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadApps} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Aplicaciones móviles {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="cuotas_compra"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={apps.map((app, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(app)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                        <ButtonDelete entity="oauth/app" id={app.id} reload={loadApps} />
                      </AllowedGuard>
                    </div>
                  ),
                  description: app.description,
                  code: app.code,
                  falseGps: (
                    <Tooltip title="Activa la restricción por GPS falso para esta aplicación">
                      <Switch
                        checked={app.false_gps_active === true || app.false_gps_active === 1}
                        onChange={(e) => toggleGeneral(app, 'false_gps_active', e.target.checked)}
                        color="secondary"
                      />
                    </Tooltip>
                  ),
                  validateVersion: (
                    <Tooltip title="Exige la última versión de la aplicación al iniciar sesión">
                      <Switch
                        checked={app.validate_version_active === true || app.validate_version_active === 1}
                        onChange={(e) => toggleGeneral(app, 'validate_version_active', e.target.checked)}
                        color="secondary"
                      />
                    </Tooltip>
                  ),
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
